module.exports = __webpack_public_path__ + "static/media/sf_100.d1a2d6bc6eed4ef4bf6f069a84ca3cfc.png";